/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WhatIsThis_occurrence$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LatestWhatIsThis_viewer$ref: FragmentReference;
declare export opaque type LatestWhatIsThis_viewer$fragmentType: LatestWhatIsThis_viewer$ref;
export type LatestWhatIsThis_viewer = {|
  +allWhatIsThis: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: WhatIsThis_occurrence$ref,
      |}
    |}>
  |},
  +$refType: LatestWhatIsThis_viewer$ref,
|};
export type LatestWhatIsThis_viewer$data = LatestWhatIsThis_viewer;
export type LatestWhatIsThis_viewer$key = {
  +$data?: LatestWhatIsThis_viewer$data,
  +$fragmentRefs: LatestWhatIsThis_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LatestWhatIsThis_viewer",
  "type": "Query",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "allWhatIsThis"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 2
    },
    {
      "kind": "LocalArgument",
      "name": "after",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "isIdentityNull",
      "type": "Boolean",
      "defaultValue": true
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "allWhatIsThis",
      "name": "__List_allWhatIsThis_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isIdentityNull",
          "variableName": "isIdentityNull"
        }
      ],
      "concreteType": "OccurrenceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "OccurrenceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Occurrence",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "WhatIsThis_occurrence",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '514ab75c7528e40e4c48cf0a716fa826';
module.exports = node;
